module.exports = "/images/vendor/vue-paycard/src/24.jpg?a3d5f6692eea05a37ebed703312f960f";